import React from "react";
import ErrorSvg from "../common/svg/ErrorSvg";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="error-page-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 d-flex align-items-center">
            <div className="error-content">
              <h1>
                404 <span>Error</span>
              </h1>
              <p>
                We believe in delivering tailored solutions that are designed to
                address your turna unique requirements. We take the time to
                understand.
              </p>
              <Link to="/" className="primary-btn3">
                <ErrorSvg />
                Back To Home
              </Link>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="error-img">
              <img
                className="img-fluid"
                src="https://appthing-website.s3.ap-south-1.amazonaws.com/error-img.png"
                alt="Error"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
